<template>
  <div v-loading="loading" class="alarmClass">
    <div :style="contentStyle">
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="所属项目" prop="projectId">
              <el-select
              disabled
                 v-model="form.projectId"
                style="width: 100%"
                placeholder="请选择所属项目"
                @change="projectIdChange"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


          <el-col :span="12">
            <el-form-item label="服务项目名称" prop="name" label-width="110px">
              <el-input
                 :disabled="model==='view'" v-model="form.name"
                placeholder="请输入服务项目名称"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="副标题" prop="subtitle">
              <el-input
                 :disabled="model==='view'" v-model="form.subtitle"
                placeholder="请输入副标题"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>



          <el-col :span="12">
            <el-form-item label="所属服务类型" prop="moduleType" label-width="110px">
              <el-select  :disabled="model==='view'" v-model="form.moduleType" 
                placeholder="请选择所属服务类型"
              style="width:100%">
                <el-option
                  v-for="item in moduleTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
              
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="24">


          <el-col :span="12">
            <el-form-item label="是否预付款" prop="dropInFlag">
                <el-radio-group  :disabled="model==='view'" v-model="form.dropInFlag" @change="dropInFlagChange">
                <el-radio :label="'1'">是</el-radio>
                <el-radio :label="'0'">否</el-radio>
              </el-radio-group>
              <money-input v-if="form.dropInFlag==1" v-model="form.dropInFee" placeholder="请输入 预付款" :disabled="model==='view'" template="append" style="width: 100%"  />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="项目客服设置" prop="customerServiceUserIds" label-width="110px">
              
                <choicePeople :disabled="model==='view'" :option="choicePeopleOption" @getPeople='getPeople'/>
            </el-form-item>
          </el-col>


        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              
              <el-input
                 :disabled="model==='view'" v-model="form.sort"
                placeholder="请输入 排序"
                maxlength="5"
              ></el-input>
              <!-- <money-input v-model="form.sort" placeholder="请输入 排序" :disabled="model==='view'" template="" style="width: 100%"  /> -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="商品图片" prop="avatarPictureUrlList">
                <vUpload 
                 :disabled="model==='view'" :message="'提示：推荐750*300， 只能上传jgp/png文件，且不大于5MB，数量最多9张'" :types="['jpg','png']"  :max="5242880" :limit="9" :fileList.sync="form.avatarPictureUrlList"></vUpload>
              </el-form-item>
            </el-col>
        </el-row>

      </el-form>
    </div>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import { setStore } from '@/util/store';
import { getStore } from '@/util/store';
import {
  getMatetial,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
  saveBasicInfo,
  getNursinghome,
  getBasicInforDetail,
  saveServiceProjectBasicInfo,
  getServiceProjectDetail,
  updateServiceProjectBasicInfo
} from '../api/serveItemManage';
import vUpload from "../components/mutil-upload.vue"
import dayjs from 'dayjs';
import choicePeople from '@/components/choicePeopleOrDept/choicePeopleInput.vue'
    export default {
  components: {vUpload,choicePeople},
  model: {
    prop: 'form',
    event: 'change',
  },
  props: {
    form: {},
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      
      choicePeopleOption: {
        projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'people', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 20,
      },
      moduleTypeList:[],
      projectList: [],
      nationData: [
        { id: 1, name: '汉族' },
        { id: 2, name: '蒙古族' },
        { id: 3, name: '回族' },
        { id: 4, name: '藏族' },
        { id: 5, name: '维吾尔族' },
        { id: 6, name: '苗族' },
        { id: 7, name: '彝族' },
        { id: 8, name: '壮族' },
        { id: 9, name: '布依族' },
        { id: 10, name: '朝鲜族' },
        { id: 11, name: '满族' },
        { id: 12, name: '侗族' },
        { id: 13, name: '瑶族' },
        { id: 14, name: '白族' },
        { id: 15, name: '土家族' },
        { id: 16, name: '哈尼族' },
        { id: 17, name: '哈萨克族' },
        { id: 18, name: '傣族' },
        { id: 19, name: '黎族' },
        { id: 20, name: '傈僳族' },
        { id: 21, name: '佤族' },
        { id: 22, name: '畲族' },
        { id: 23, name: '高山族' },
        { id: 24, name: '拉祜族' },
        { id: 25, name: '水族' },
        { id: 26, name: '东乡族' },
        { id: 27, name: '纳西族' },
        { id: 28, name: '景颇族' },
        { id: 29, name: '柯尔克孜族' },
        { id: 30, name: '土族' },
        { id: 31, name: '达翰尔族' },
        { id: 32, name: '么佬族' },
        { id: 33, name: '羌族' },
        { id: 34, name: '布朗族' },
        { id: 35, name: '撒拉族' },
        { id: 36, name: '毛南族' },
        { id: 37, name: '仡佬族' },
        { id: 38, name: '锡伯族' },
        { id: 39, name: '阿昌族' },
        { id: 40, name: '普米族' },
        { id: 41, name: '塔吉克族' },
        { id: 42, name: '怒族' },
        { id: 43, name: '乌孜别克族' },
        { id: 44, name: '俄罗斯族' },
        { id: 45, name: '鄂温克族' },
        { id: 46, name: '德昂族' },
        { id: 47, name: '保安族' },
        { id: 48, name: '裕固族' },
        { id: 49, name: '京族' },
        { id: 50, name: '塔塔尔族' },
        { id: 51, name: '独龙族' },
        { id: 52, name: '鄂伦春族' },
        { id: 53, name: '赫哲族' },
        { id: 54, name: '门巴族' },
        { id: 55, name: '珞巴族' },
        { id: 56, name: '基诺族' },
      ],
      contentStyle: '',
      formRules: {
        // nursinghomeId: [{ required: true, message: '养老院名称不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '服务项目名称不能为空', trigger: 'blur' }],
        projectId: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }],
        subtitle: [{ required: true, message: '副标题不能为空', trigger: 'blur' }],
        moduleType: [{ required: true, message: '所属服务类型不能为空', trigger: 'blur' }],
        dropInFlag: [{ required: true, message: '是否预付款不能为空', trigger: 'blur' }],
        customerServiceUserIds: [{ required: true, message: '项目客服设置不能为空', trigger: 'blur' }],
        sort: [{ required: true, message: '排序不能为空', trigger: 'blur' },
        {
          max:9999, min:0, pattern:/^[0-9]*[0-9][0-9]*$/, message: '排序格式错误', trigger: 'blur'
        }],
        avatarPictureUrlList: [{ required: true, message: '商品图片不能为空', trigger: 'blur' }],
      },
      matetialList: [],
      maritalStatusList:[],
      economicSourceList:[],
      bloodTypeList:[],
      educationalLevelTypeList:[],
      retiredOccupationTypeList:[],
      politicalFeaturesList:[],
      yesNoList:[],
      originalResidenceList:[],
      personnelCategoryList:[],
      religiousBeliefList:[],
      laborCapacityList:[],
      medicalSecurityList:[],
      nursinghomeIdList:[],
        choicePeopleOption:{
         projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'unlimitPeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 1,
      },
    };
  },
  created() {
      if(this.model === 'add'){
        // this.form = this._.cloneDeep({
        //   nursinghomeId: this.form.nursinghomeId,
        //   name:'',
        //   birthday:''
        // });
      }
    this.initData();
  },
  mounted() {
    this.calcHeight();
    var relativeTime = require('dayjs/plugin/relativeTime')
// import AdvancedFormat from 'dayjs/plugin/advancedFormat' // ES 2015

    dayjs.extend(relativeTime)
  },
  watch: {},
  methods: {
    dropInFlagChange(val){
      this.form = this._.cloneDeep(this.form);
    },
    //选人组件获取人员后赋值
    getPeople(obj){
        console.log("getPeople==========>",obj);
        let arr = [];
        obj.forEach((ele)=>{
            arr.push(ele.id);
        });
        this.form.userIdList = arr;
        this.form.customerServiceUserIds = arr.join(',');
    //   this.ruleForm.userIds = obj.id
    },
    birthdayChange(val){
      let dateNow = this.dayjs(new Date());
      console.log("birthdayChange===========>",dateNow.diff(val,'year'));
      this.form.age = dateNow.diff(val,'year');
      this.form = this._.cloneDeep(this.form);
    },
    getGenderByIdNumber(idNumber) {
      if (idNumber) {
        let genderCode; // 性别代码
        if (idNumber.length == 18) {
          // 二代身份证号码长度为18位（第17位为性别代码）
          genderCode = idNumber.charAt(16);
        } else if (idNumber.length == 15) {
          // 一代身份证号码长度为15位（第15位为性别代码）
          genderCode = idNumber.charAt(14);
        }
        if (genderCode && !isNaN(genderCode)) {
          // 两代身份证号码的性别代码都为男奇女偶
          if (parseInt(genderCode) % 2 == 0) {
            return 'female';
          }
          return 'male';
        }
      }
    },

    async initData(cb) {
      console.log(this.form,this.model)
      getProjectList().then((res) => {
        this.projectList = res.data;
      });
      
    this.choicePeopleOption.projectId = this.form.projectId;

      getDictionary("out_order_module_type").then(res=>{
        this.moduleTypeList = res.data
      })
      
      
      if (this.model === 'add') {
          this.form.dropInFlag = '1';
        console.log(this.form,"getBasicInforDetail==========>");
        if(getStore({name:'elderId'})){
          // getBasicInforDetail({id: getStore({name:'elderId'})}).then(res=>{
          //   console.log("getBasicInforDetail========>",res.data);
          //   this.form = res.data;
          // })
        }else{
          
          this.form = this.row;
        }
      } else {console.log(this.form,"getBasicInforDetail==========>");
        // getBasicInforDetail({id: this.form.id}).then(res=>{
        //   this.form = res.data;
        //   console.log("getBasicInforDetail========>",res.data,);
        // })
          getServiceProjectDetail({id: this.form.id}).then(res=>{
            this.form = this._.cloneDeep(res.data);
            this.form.moduleType = this.form.moduleType.toString();
            this.form.avatarPictureUrlList = this._.cloneDeep(this.form.attachList);
            this.handlePeople();
            console.log("getBasicInforDetail========>",res.data,);
            this.$emit('init',this.form);
            // if(cb){
            //   cb(this.form);
            // }
          })
          // this.form = this.row;
      }
    },
    
      handlePeople(){
          let idArry = this.form.customerServiceUserIds.split(',')
          let nameArry = this.form.customerServiceUserNames.split(',')
          let length = idArry.length
          for(let i =0;i<length;i++){
              let obj ={
                   id:idArry[i],
                    realName:nameArry[i],
              }
              this.choicePeopleOption.selectList.push(obj)
          }
      },
    calcHeight() {
      let bodyHight = document.body.clientHeight;
      let contentHeight = bodyHight - 340;
      this.contentStyle =
        'max-height:' + contentHeight + 'px; overflow-y: scroll;overflow-x: hidden;';
    },
    saveRecord(cb) {
      let result = false;
      this.$refs['formRef'].validate((valid) => {
        console.log('子', valid);
        result = valid;
        console.log(this.form);
        // if((this.form.dropInFlag == 1)&&!this.form.dropInFee){
        //   this.$message.error('请填写预付款');
        //   return;
        // }
        if((this.form.dropInFlag == 1)&&!this.form.dropInFee){
          this.$message.error('请填写预付款');
          return;
        }
        if(this.form.avatarPictureUrlList&&this.form.avatarPictureUrlList.length>0){

        let arrPic = [];
        this.form.avatarPictureUrlList.forEach((ele)=>{
          arrPic.push({id:ele.id});
        })
        this.form.attachList = this._.cloneDeep(arrPic);
        }
        if(result){
          
      if (this.model === 'add') {
          saveServiceProjectBasicInfo({
            // id:getStore({name:'elderId'}),
            ...this.form
            }).then((res)=>{
            this.$message.success('操作成功！',res);
            this.$emit('success', this.form);
            setStore({
              name: 'elderId',
              content: res.data
            })
            if(cb)cb();

          });
      }else{
        
          updateServiceProjectBasicInfo({
            // id:getStore({name:'elderId'}),
            ...this.form
            }).then((res)=>{
            this.$message.success('操作成功！',res);
            this.$emit('success', this.form);
            setStore({
              name: 'elderId',
              content: res.data
            })
            if(cb)cb();

          });
      }
        }
      });
      return result;
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
